export const  BASE_API_URL='https://shippay.shipwaves.com/api';
// export const  BASE_API_URL='http://localhost:3000';
